import React from 'react';
import './AlertText.scss';
import { AlertAction, AlertButtons, SetState } from 'types';

interface AlertTextProps {
    icon: string;
    title: string;
    message: string;
    setMessage: SetState<string>;
    buttons?: AlertButtons;
    actions?: AlertAction[];
}

export default function AlertText({ icon, title, message, setMessage, buttons, actions }: AlertTextProps) {

    // Cierre de la alerta
    const handdleButton = () => {
        setMessage('');
    };

    return (
        <>
            <button
                type="button"
                className="overflow"
                aria-label="Close dialog"
                onClick={handdleButton}
            />
            <div className={`alert-successxx ${actions?.length ? 'has-actions' : ''}`} translate="no">

                {/* Boton de cierre de alerta */}
                <button onClick={handdleButton} className='close'>
                    <i className="fa-solid fa-xmark"></i>
                </button>

                {/* Icono de alerta */}
                <div className='icon'>
                    <i className={`fa-solid ${icon}`}></i>
                </div>

                <h2 className='title'>{title}</h2>

                <p className='messaje'>{message}</p>

                {/* Botones de accion */}
                {actions && actions.length > 0 && (
                    <div className='actions'>
                        {actions.map((action) => (
                            <button key={action.name} type="button" className='action' onClick={action.onClick}>
                                {action.image ? (
                                    <img className="action_image" src={action.image} alt="" />
                                ) : (
                                    action.icon && <i className={`fa-solid ${action.icon}`}></i>
                                )}
                                <span>
                                    <strong>{action.name}</strong>
                                    {action.hint && <em>{action.hint}</em>}
                                </span>
                            </button>
                        ))}
                    </div>
                )}

                {buttons && <div className='buttons'>
                    {buttons.btn1name && <button className='button1' onClick={buttons.btn1Action}>
                        <span>{buttons.btn1name}</span>
                    </button>}

                    {buttons.btn2name && <button className='button1' onClick={buttons.btn2Action}>
                        <span>{buttons.btn2name}</span>
                    </button>}
                </div>}
            </div>
        </>
    );
}
